
import React, { useEffect, useState } from "react";
import styles from "./scss/videoPreview.module.scss";
import { Player,BigPlayButton, ControlBar, ReplayControl, ForwardControl, PlaybackRateMenuButton } from 'video-react';
import ChatLike from "../chatWidgets/chatLike";
type audioTypeProps = {
  data: any;
}
type videoMessageState = {
  pausePlay: any;
  duration: any;
  videoId: string;
  playerIndex:any;
}

export default function VideoPlayer({ data }: audioTypeProps) {
  const messageBody = data && data?.message?.body;
  let { timestamp } = data;
  let indexId = data?.indexId !== undefined ? data?.indexId : timestamp;
  const [videoState, setvideoState] = useState<videoMessageState>({ pausePlay: false, duration: '00:00', videoId: "",playerIndex:1 });
  const [seektime, setseektime] = useState(0);
  const [currentduration, setCurrentduration] = useState("00:00");
  //let htimestamp = moment(timestamp).format('hh:mm A');
  let myVideo: any = document.getElementById(indexId);
  

  let timeDuration: any;
  let duration = myVideo?.duration;
  let d = Number(duration);
  let h = Math.floor(d / 3600);
  let m = Math.floor(d % 3600 / 60);
  let s = Math.floor(d % 3600 % 60);

  let hDisplay = h > 0 ? `0${h}` : h > 10 ? h : "00";
  let mDisplay = m < 9 ? `0${m}` : m > 10 ? m : "00";
  let sDisplay = s < 9 ? `0${s}` : s > 10 ? s : "00";
  timeDuration = hDisplay > 0 ? `${hDisplay}:${mDisplay}:${sDisplay}` : `${mDisplay}:${sDisplay}`;

  useEffect(() => {
    let myVideo: any = document.getElementById(indexId);
    let timeDuration: any;
    let duration = myVideo?.duration;
    let d = Number(duration);
    let h = Math.floor(d / 3600);
    let m = Math.floor(d % 3600 / 60);
    let s = Math.floor(d % 3600 % 60);

    let hDisplay = h > 0 ? `0${h}` : h > 10 ? h : "00";
    let mDisplay = m < 9 ? `0${m}` : m > 10 ? m : "00";
    let sDisplay = s < 9 ? `0${s}` : s > 10 ? s : "00";
    timeDuration = hDisplay > 0 ? `${hDisplay}:${mDisplay}:${sDisplay}` : `${mDisplay}:${sDisplay}`;
    setvideoState({ ...videoState, duration: timeDuration });

    myVideo?.addEventListener('pause', (event: any) => {
      let myVideo: any = document.getElementById(indexId);
      setvideoState({ ...videoState, pausePlay: false,playerIndex:Math.floor(myVideo?.currentTime)});
    });

    return () => {
      myVideo?.removeEventListener('pause', (event: any) => {
      });
    };

  }, [timeDuration]);

  const videoPlay = () => {
    try {
      var videos: any = document.querySelectorAll('.videoFluid');
      videos.forEach((element: any) => {
        if (element.pause) {
          element.pause();
        }
      });
      let video: any = document.getElementById(indexId);
      setvideoState({ ...videoState, pausePlay: !videoState.pausePlay});
      if (!videoState.pausePlay) {
        video.addEventListener("timeupdate", seektimeupdate, false);
        video?.play();
      }
      else {
        video?.pause();
      }
    }
    catch (e) {
      console.log("error is", e);
    }
  };


  const seektimeupdate = () => {
    //let seekslider:any = document.getElementById("seekslider");
    let vid: any = document.getElementById(indexId);
    //var nt = vid.currentTime * (100 / vid.duration);
    //seekslider.value = nt;
    if(vid){
    setseektime(vid.currentTime)
    var curmins: any = Math.floor(vid.currentTime / 60);
    var cursecs: any = Math.floor(vid.currentTime - curmins * 60);
    var durmins: any = Math.floor(vid.duration / 60);
    var dursecs: any = Math.floor(vid.duration - durmins * 60);
    if (cursecs < 10) { cursecs = "0" + cursecs; }
    if (dursecs < 10) { dursecs = "0" + dursecs; }
    if (curmins < 10) { curmins = "0" + curmins; }
    if (durmins < 10) { durmins = "0" + durmins; }

    let currDuration = curmins + ":" + cursecs

    setCurrentduration(currDuration)
    if (currDuration === getduration(vid.duration) && videoState.pausePlay) {
      setvideoState({ ...videoState, pausePlay: false });
      vid.pause();
    }
    console.log(seektime,currentduration)
  }
    
  }

  const getduration = (time: any) => {
    let timeDuration: any;
    let d = Number(time);
    let h = Math.floor(d / 3600);
    let m = Math.floor(d % 3600 / 60);
    let s = Math.floor(d % 3600 % 60);

    let hDisplay = h > 0 ? `0${h}` : h > 10 ? h : "00";
    let mDisplay = m < 9 ? `0${m}` : m > 10 ? m : "00";
    let sDisplay = s < 9 ? `0${s}` : s > 10 ? s : "00";
    timeDuration = hDisplay > 0 ? `${hDisplay}:${mDisplay}:${sDisplay}` : `${mDisplay}:${sDisplay}`;
    return timeDuration;
  }


  return (
    <>

<div className={styles.imagezoom}>
  <div className={styles.imagezoomfit}>
      <div className="customVideoPlayer">
        <Player src={messageBody?.filePath} playsInline fluid={false} width={500} height={400} aspectRatio='1:2'>
          <BigPlayButton position="center" />
          <ControlBar autoHide={true}>
            <ReplayControl seconds={5}  order={2.1}/>
            <ForwardControl seconds={5} order={2.3}/>
            <PlaybackRateMenuButton rates={[5, 2, 1, 0.5, 0.1]}  order={8}/>
          </ControlBar>
         
        </Player>
       
        
        <div className={videoState.pausePlay ? styles.pauseIcon : styles.playIcon}
         onClick={videoPlay}
        >
        </div>
      </div>
      <ChatLike className='likePreview' placement="topRight"
                tooltipTitle={data?.likeduserdetails} message={data} />
      </div>
      </div>
    </>
  );
};

